import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as appsActions from "../../actions/appsActions";
import * as constants from "../../constants";

const deleteAppLogic = createLogic({
	type: ActionTypes.DELETE_APP,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					headers: { Authorization: "Bearer " + token },
				});
				api.delete(`/apps/${action.appID}`)
					.then(() => {
						dispatch(appsActions.deleteAppSuccess());
						done();
					})
					.catch(error => {
						dispatch(appsActions.deleteAppFail(error));
						done();
					});
			});
	},
});

export default [deleteAppLogic];
